<template>
  <VDialog
    v-model="_dialog"
    persistent
    max-width="900"
  >
    <VLayout
      row
      wrap
      fill-height
    >
      <VFlex xs8>
        <VCard
          height="650"
        >
          <VToolbar
            dark
            color="primary"
          >
            <VBtn
              icon
              dark
              @click.prevent="onCloseDialog"
            >
              <VIcon>
                close
              </VIcon>
            </VBtn>
            <VToolbarTitle>
              {{ titleName }}
            </VToolbarTitle>
            <VSpacer />
            <VToolbarItems>
              <VBtn
                dark
                flat
                @click="onSaveClicked"
              >
                save
              </VBtn>
            </VToolbarItems>
          </VToolbar>
          <VCardText>
            <VLayout
              row
              wrap
              fill-height
            >
              <VFlex
                xs12
              >
                <VForm
                  ref="form"
                  v-model="valid"
                >
                  <VContainer>
                    <VLayout
                      row
                      wrap
                      fill-height
                    >
                      <VFlex
                        xs12
                        sm6
                      >
                        <VCheckbox
                          v-model="enabled"
                          label="Enabled"
                        />
                      </VFlex>
                      <VFlex
                        xs12
                        sm6
                      >
                        <VTextField
                          v-model="name"
                          label="name"
                          :rules="rules.required"
                        />
                      </VFlex>
                      <VFlex xs12>
                        <VSelect
                          v-model="ruleType"
                          :disabled="!enabled"
                          :items="Object.values(ruleTypeDict)"
                          menu-props="auto"
                          label="Type"
                          hide-details
                          outline
                        />
                      </VFlex>
                      <div
                        v-if="ruleType === ruleTypeDict['STAY_IN_CONTACT']"
                        class="options"
                      >
                        <VLayout
                          row
                          wrap
                        >
                          <VFlex xs6>
                            <VCheckbox
                              v-model="repeated"
                              label="Repeated"
                              :disabled="!enabled"
                            />
                          </VFlex>
                          <VFlex xs6>
                            <VCheckbox
                              v-if="applyToNewOption"
                              v-model="applyToNew"
                              label="Apply to new contacts"
                              :disabled="!enabled"
                            />
                          </VFlex>
                          <VFlex
                            xs12
                            sm6
                          >
                            <VTextField
                              v-model="frequency"
                              label="How often (days)"
                              :disabled="!enabled"
                              :mask="numberMask"
                              :rules="rules.nonZero"
                            />
                          </VFlex>
                          <VFlex
                            xs12
                            sm6
                          >
                            <VTooltip right>
                              <template v-slot:activator="{ on }">
                                <VTextField
                                  v-model="skipDays"
                                  :disabled="!enabled"
                                  :mask="numberMask"
                                  label="Skip if contacted within days"
                                  v-on="on"
                                />
                              </template>
                              <span>
                                Zero day means no skip.<br>
                                One day means skipping if sent within the same day.<br>
                                Two days means skipping if sent today or yesterday, etc.
                              </span>
                            </VTooltip>
                          </VFlex>
                        </VLayout>
                      </div>
                      <div
                        v-if="ruleType === ruleTypeDict['EVENT_FOLLOWUP']"
                        class="options"
                      >
                        <VLayout
                          row
                          wrap
                        >
                          <VFlex
                            xs12
                            sm6
                          >
                            <VCheckbox
                              v-model="applyToBirthday"
                              :label="`Apply to birthday`"
                              :disabled="!enabled"
                            />
                          </VFlex>
                          <VFlex
                            xs12
                            sm6
                          >
                            <VCheckbox
                              v-if="applyToBirthday && applyToAllOption"
                              v-model="applyToAll"
                              :label="`Apply to all contacts`"
                              :disabled="!enabled"
                            />
                          </VFlex>
                          <VFlex
                            xs12
                            sm6
                          >
                            <VTextField
                              v-model="remindDays"
                              :disabled="!enabled"
                              append-outer-icon="add"
                              prepend-icon="remove"
                              :label="`Message days ${remindDays >= 0 ? `after` : `before` }`"
                              outline
                              :rules="rules.remindDaysRule"
                              @click:append-outer="onAddDayClicked('remindDays')"
                              @click:prepend="onRemoveDayClicked('remindDays')"
                            />
                          </VFlex>
                          <VFlex
                            xs12
                            sm6
                          >
                            <VTooltip right>
                              <template v-slot:activator="{ on }">
                                <VTextField
                                  v-model="skipDays"
                                  :disabled="!enabled"
                                  :mask="numberMask"
                                  label="Skip if contacted within days"
                                  outline
                                  v-on="on"
                                />
                              </template>
                              <span>
                                Zero day means no skip.<br>
                                One day means skipping if sent within the same day.<br>
                                Two days means skipping if sent today or yesterday, etc.
                              </span>
                            </VTooltip>
                          </VFlex>
                          <VFlex
                            v-if="!applyToBirthday"
                            xs12
                          >
                            <VueCtkDateTimePicker
                              v-model="eventDate"
                              class="datePicker"
                              label="Select Date"
                              :class="[{dateDisabled: !enabled}]"
                              :disabled="!enabled"
                              format="YYYY-MM-DD"
                              formatted="ll"
                              only-date
                              overlay
                              input-size="lg"
                            />
                          </VFlex>
                        </VLayout>
                      </div>
                      <VFlex
                        xs12
                        sm6
                      >
                        <VueCtkDateTimePicker
                          v-model="scheduleTime"
                          class="datePicker"
                          :class="[{dateDisabled: !enabled}]"
                          :disabled="!enabled"
                          input-size="lg"
                          minute-interval="5"
                          only-time
                          no-header
                          no-shortcuts
                          overlay
                          color="firebrick"
                          label="Schedule Time"
                          format="hh:mm a"
                          formatted="hh:mm a"
                          minute-interavl="10"
                        />
                      </VFlex>
                      <VFlex
                        xs12
                        sm6
                      >
                        <VAutocomplete
                          v-model="selectedTimeZone"
                          chips
                          clearable
                          :disabled="!enabled"
                          :items="timeZones"
                          :rules="rules.required"
                          label="Time Zone*"
                        />
                      </VFlex>
                    </VLayout>
                  </VContainer>
                </VForm>
              </VFlex>
            </VLayout>
          </VCardText>
        </VCard>
      </VFlex>
      <VFlex xs4>
        <FollowupMessageDrawer
          :messages="ruleMessages"
          :drawer="_dialog"
          :width="300"
          :height="650"
          :rule-index="ruleIndex"
        />
      </VFlex>
    </VLayout>
    <ProgressDialogCard
      :description="statusMessage"
      :dialog="loadingStatus"
      indeterminate
    />
  </VDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { automationMapActions } from '@/store/utils'
import moment from 'moment-timezone'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import FollowupMessageDrawer from './FollowupMessageDrawer'
import ProgressDialogCard from '@/components/ProgressDialogCard'
import _ from 'lodash'

export default {
  name: 'FollowupDetailDialogCard',
  components: { FollowupMessageDrawer, VueCtkDateTimePicker, ProgressDialogCard },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    ruleIndex: {
      type: Number,
      default: null
    },
    titleName: {
      type: String,
      default: 'Edit Rule'
    },
    saveMethod: {
      type: Function,
      default: function () {}
    },
    saveMethodGql: {
      type: Object,
      default: function () {
        return null
      }
    },
    ruleTypeDict: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ruleData: {
      type: Object,
      default () {
        return {}
      }
    },
    isRuleEnabled: {
      type: Function,
      default: function (index) {}
    },
    setRuleEnabled: {
      type: Function,
      default: function (index) {}
    },
    applyToNewOption: {
      type: Boolean,
      default: false
    },
    applyToAllOption: {
      type: Boolean,
      default: false
    },
    ruleHolderId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      valid: false,
      numberMask: '###',
      timeZones: moment.tz.names(),
      drawer: true,
      rules: {
        required: [value => !!value || 'Required.'],
        nonZero: [
          value => !!value || 'Required',
          value => value > 0 || 'Should be greater than one day'
        ],
        remindDaysRule: [
          value => (value === 0 || !!value) || 'Required',
          value => (Number(value) < 366 && Number(value) > -366) || 'Should be within -365 to 365 days'
        ]
      },
      test: false,
      defaultRuleData: {}
    }
  },
  computed: {
    ...mapGetters({
      loadingStatus: 'automation/getLoadingStatus',
      statusMessage: 'automation/getLoadingText'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.drawer = val
        this.$emit('update:dialog', val)
      }
    },
    name: {
      get: function () {
        return _.get(this.ruleData, 'name', '')
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateRuleNameByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'name', val)
        }
      }
    },
    ruleType: {
      get: function () {
        return this.ruleTypeDict[_.get(this.ruleData, 'ruleType', 'STAY_IN_CONTACT')]
      },
      set: function (val) {
        const entries = Object.entries(this.ruleTypeDict)
        entries.some((item) => {
          if (item[1] === val) {
            if (this.ruleIndex === 0 || this.ruleIndex) {
              this.updateRuleTypeByIndex({ index: this.ruleIndex, value: item[0] })
            } else {
              _.set(this.ruleData, 'ruleType', item[0])
            }
            return true
          }
          return false
        })
      }
    },
    enabled: {
      get: function () {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          return this.isRuleEnabled(this.ruleIndex)
        } else {
          return _.get(this.ruleData, 'enabled', false)
        }
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.setRuleEnabled(this.ruleIndex)
        } else {
          _.set(this.ruleData, 'enabled', val)
        }
      }
    },
    repeated: {
      get: function () {
        return _.get(this.ruleData, 'repeated', false)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateRepeatedByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'repeated', val)
        }
      }
    },
    applyToNew: {
      get: function () {
        return _.get(this.ruleData, 'applyToNew', false)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateApplyToNewByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'applyToNew', val)
        }
      }
    },
    frequency: {
      get: function () {
        return _.get(this.ruleData, 'frequency', 0)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateFrequencyByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'frequency', val)
        }
      }
    },
    skipDays: {
      get: function () {
        return _.get(this.ruleData, 'skipContactedWithin', 0)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateSkipContactedWithinByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'skipContactedWithin', val)
        }
      }
    },
    eventDate: {
      get: function () {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          return moment.tz(new Date(this.ruleData.scheduledDateTime), this.ruleData.timeZone)
        } else {
          return _.get(this.ruleData, 'eventDate', moment().format('YYYY-MM-DD'))
        }
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          const value = moment.tz(`${val} ${this.scheduleTime.format('LT')}`,
            'YYYY-MM-DD hh:mm a', this.ruleData.timeZone).toISOString()
          this.updateScheduledDateTimeByIndex({ index: this.ruleIndex, value })
        } else {
          _.set(this.ruleData, 'eventDate', val)
        }
      }
    },
    applyToBirthday: {
      get: function () {
        return _.get(this.ruleData, 'applyToBirthday', false)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateApplyToBirthdayByIndex({ index: this.ruleIndex, value: val })
          if (!val) { this.updateApplyToAllByIndex({ index: this.ruleIndex, value: val }) }
        } else {
          _.set(this.ruleData, 'applyToBirthday', val)
          if (!val) { _.set(this.ruleData, 'applyToBirthday', val) }
        }
      }
    },
    applyToAll: {
      get: function () {
        return _.get(this.ruleData, 'applyToAll', false)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateApplyToAllByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'applyToAll', val)
        }
      }
    },
    remindDays: {
      get: function () {
        return _.get(this.ruleData, 'remindDays', 0)
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateRemindDaysByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'remindDays', val)
        }
      }
    },
    scheduleTime: {
      get: function () {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          return moment.tz(new Date(this.ruleData.scheduledDateTime), this.ruleData.timeZone)
        } else {
          return _.get(this.ruleData, 'scheduleTime', '08:00 am')
        }
      },
      set: function (scheduleTime) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          const value = moment.tz(`${this.eventDate.format('YYYY-MM-DD')} ${scheduleTime}`,
            'YYYY-MM-DD hh:mm a', this.ruleData.timeZone).toISOString()
          this.updateScheduledDateTimeByIndex({ index: this.ruleIndex, value })
        } else {
          _.set(this.ruleData, 'scheduleTime', scheduleTime)
        }
      }
    },
    selectedTimeZone: {
      get: function () {
        return _.get(this.ruleData, 'timeZone', moment.tz.guess())
      },
      set: function (val) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          this.updateTimeZoneByIndex({ index: this.ruleIndex, value: val })
        } else {
          _.set(this.ruleData, 'timeZone', val)
        }
      }
    },
    ruleMessages: {
      get: function () {
        return _.get(this.ruleData, 'ruleMessage', [{ body: '' }])
      },
      set: function (val) {
        _.set(this.ruleData, 'ruleMessage', val)
      }
    }
  },
  watch: {
    ruleData: function () {
      this.defaultRuleData = JSON.parse(JSON.stringify(this.ruleData))
    }
  },
  methods: {
    ...mapActions(Object.assign(automationMapActions, {})),
    onCloseDialog () {
      this._dialog = false
      this.resetNewDialogData()
    },
    async onSaveClicked () {
      const success = await this.saveMethod({
        ruleData: this.ruleData,
        gql: this.saveMethodGql,
        index: this.ruleIndex,
        ruleHolderId: this.ruleHolderId })
      this._dialog = !success
      if (success) { this.resetNewDialogData() }
    },
    resetNewDialogData () {
      if (this.ruleIndex === 0 || this.ruleIndex) { return }
      this.name = this.defaultRuleData.name
      this.ruleType = this.ruleTypeDict[this.defaultRuleData.ruleType]
      this.enabled = this.defaultRuleData.enabled
      this.repeated = this.defaultRuleData.repeated
      this.applyToNew = this.defaultRuleData.applyToNew
      this.frequency = this.defaultRuleData.frequency
      this.skipDays = this.defaultRuleData.skipContactedWithin
      this.eventDate = this.defaultRuleData.eventDate
      this.applyToBirthday = this.defaultRuleData.applyToBirthday
      this.applyToAll = this.defaultRuleData.applyToAll
      this.remindDays = this.defaultRuleData.remindDays
      this.scheduleTime = this.defaultRuleData.scheduleTime
      this.selectedTimeZone = this.defaultRuleData.timeZone
      this.ruleMessages = this.defaultRuleData.ruleMessage
    },
    onAddDayClicked (name) {
      const val = _.get(this.ruleData, name, null)
      if (val !== null) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          switch (name) {
            case 'frequency':
              this.updateFrequencyByIndex({ index: this.ruleIndex, value: Number(val) + 1 })
              break
            case 'remindDays':
              this.updateRemindDaysByIndex({ index: this.ruleIndex, value: Number(val) + 1 })
              break
            default:
              break
          }
        } else {
          _.set(this.ruleData, name, val + 1)
        }
      }
    },
    onRemoveDayClicked (name) {
      const val = _.get(this.ruleData, name, null)
      if (val !== null) {
        if (this.ruleIndex === 0 || this.ruleIndex) {
          switch (name) {
            case 'frequency':
              this.updateFrequencyByIndex({ index: this.ruleIndex, value: Number(val) - 1 })
              break
            case 'remindDays':
              this.updateRemindDaysByIndex({ index: this.ruleIndex, value: Number(val) - 1 })
              break
            default:
              break
          }
        } else {
          _.set(this.ruleData, name, val - 1)
        }
      }
    }
  }
}
</script>

<style scoped>
  .options {
    width: 100%;
    margin: 15px 0px 15px 0px;
    padding: 0px 10px 0px 10px;
  }
  .v-text-field {
    padding: 12px 10px 0px 10px;
  }
  .datePicker {
    margin-bottom: 20px;
  }
  .datePicker >>> .field.is-dark .field-input {
    color: white;
    border: 2px solid hsla(0,0%,100%,.7);
  }
  .dateDisabled >>> .field.is-disabled .field-input {
    color: gray;
    background: bottom;
  }
  .dateDisabled >>> .field.is-dark.is-disabled .field-label {
    color: hsla(0,0%,100%,.7);
  }
  .dateDisabled >>> .field.is-disabled .field-input::placeholder{
    color: hsla(0,0%,100%,.7)
  }
</style>
